import React, { useEffect, useState, useCallback } from 'react'
import { postData } from '../../../js/helpers/apiHelper'
import { Modal } from '@mui/material'
import SanitizeHtml from '../Base/SanitizeHtml/SanitizeHtml'

const TermsText = ({ endpoint, termsOnly = true }) => {
  const [openModal, setOpenModal] = useState(false)
  const [termsResponseData, setTermsResponseData] = useState(null)
  const [currentTermsContent, setCurrentTermsContent] = useState(null)

  const fetchData = useCallback(async () => {
    try {
      const response = await postData(endpoint, { termsOnly })
      if (!response.hasError) {
        setTermsResponseData(response.data.extraData)
      }
    } catch (err) {
      console.error(err)
    }
  }, [endpoint])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  const createTerms = useCallback(() => {
    if (!termsResponseData) return null
    return termsResponseData.map((item, index) => (
      <React.Fragment key={index}>
        &nbsp;
        {item.dataType === 'link' ? (
          <a href={item.dataValue} target="_blank">
            {item.name}
          </a>
        ) : (
          <span
            className="b-terms__button"
            onClick={() => handleTermsModal(item.dataValue)}>
            {item.name}
          </span>
        )}
        {index < termsResponseData.length - 1 && ','}
      </React.Fragment>
    ))
  }, [termsResponseData])

  const handleTermsModal = (data) => {
    setOpenModal(true)
    setCurrentTermsContent(data)
  }

  return (
    <>
      <div>
        <div className="b-terms__button">{createTerms()}</div>
      </div>

      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        disableScrollLock={true}>
        <div
          className="s-modify-form__modal"
          style={{
            maxHeight: 'calc(100vh - 200px)',
            overflow: 'auto',
            padding: '40px 0',
          }}>
          <button
            type="button"
            title="Close"
            className="btn p-0 s-modify-form__modal__close"
            onClick={() => setOpenModal(false)}>
            <i className="icon-x"></i>
          </button>
          <div style={{ overflow: 'auto', padding: '34px' }}>
            <SanitizeHtml html={currentTermsContent} />
          </div>
        </div>
      </Modal>
    </>
  )
}

export default TermsText
